import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import UIMultipleSelection from '@ui/QuestionsType/MultipleSelection'

@inject('surveyState')
@observer
export default class MultipleSelection extends Component {
  handleChange = selected => this.props.onPartial(selected)

  handleFormChange = value => this.props.mapped.updateFormValue(value)

  render() {
    const { mapped, inactive, variablesOptions } = this.props

    const classes = []
    if (mapped.cssClasses && mapped.cssClasses.length > 0) {
      classes.push(mapped.cssClasses.join(' '))
    }

    return (
      <UIMultipleSelection
        id={mapped.name}
        onChange={this.handleChange}
        options={mapped.choices}
        buttonClassName={classes.join(' ')}
        showForm={mapped.showForm}
        withForm={mapped.hasOther}
        formValue={mapped.formValue}
        formPlaceholder={mapped.formPlaceholder}
        onChangeForm={this.handleFormChange}
        inactive={inactive}
        variablesOptions={variablesOptions}
      />
    )
  }
}
